import { render } from "./Withdrawal.vue?vue&type=template&id=bd70e328&scoped=true"
import script from "./Withdrawal.vue?vue&type=script&lang=js"
export * from "./Withdrawal.vue?vue&type=script&lang=js"

import "./Withdrawal.vue?vue&type=style&index=0&id=bd70e328&scoped=true&lang=scss"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd70e328"]])

export default __exports__